var map = {
	"./airplane.svg": 79009,
	"./answer-arrow.svg": 42229,
	"./apple.svg": 3249,
	"./archive-tick.svg": 36635,
	"./arrow-down-2.svg": 38666,
	"./arrow-down.svg": 31759,
	"./arrow-left.svg": 65648,
	"./arrow-right-2.svg": 99642,
	"./arrow-right.svg": 76415,
	"./arrow-round.svg": 9689,
	"./arrow-up-right.svg": 35153,
	"./arrow-up.svg": 46688,
	"./attach.svg": 78912,
	"./book-2.svg": 85641,
	"./book-active.svg": 63823,
	"./book-inactive.svg": 19774,
	"./books.svg": 39615,
	"./brain.svg": 77245,
	"./calendar.svg": 85033,
	"./cards-three.svg": 34463,
	"./category-active.svg": 67350,
	"./category-inactive.svg": 107,
	"./chart.svg": 43237,
	"./check.svg": 82497,
	"./checks.svg": 18256,
	"./clipboard.svg": 75543,
	"./clock.svg": 92075,
	"./close-circle.svg": 49866,
	"./close.svg": 35837,
	"./cloud.svg": 81326,
	"./detach.svg": 44146,
	"./done.svg": 56903,
	"./edit.svg": 975,
	"./eye-close.svg": 47349,
	"./eye-open.svg": 92815,
	"./film-reel.svg": 69630,
	"./fire-progress.svg": 46217,
	"./fire.svg": 2047,
	"./flag-2.svg": 32304,
	"./flag.svg": 41113,
	"./flash.svg": 46567,
	"./flower-lotus.svg": 61708,
	"./folder-add.svg": 35693,
	"./folder-open.svg": 86692,
	"./folder.svg": 30811,
	"./gallery-add.svg": 56205,
	"./google.svg": 3486,
	"./graduation-cap-active.svg": 23003,
	"./graduation-cap-inactive.svg": 65730,
	"./grid.svg": 33591,
	"./headphone.svg": 5671,
	"./heart-checker-active.svg": 95098,
	"./heart-checker-unactive.svg": 71851,
	"./heart.svg": 49733,
	"./home-active.svg": 72997,
	"./home-inactive.svg": 51840,
	"./info-notification.svg": 11521,
	"./info.svg": 36947,
	"./lamp-charge.svg": 9354,
	"./like.svg": 45998,
	"./link-open.svg": 15248,
	"./lock.svg": 45482,
	"./logout.svg": 34277,
	"./maximize.svg": 10977,
	"./minus.svg": 48441,
	"./money-receive.svg": 98813,
	"./money-wavy.svg": 88941,
	"./moon-solid.svg": 11962,
	"./moon.svg": 77628,
	"./note-active.svg": 15882,
	"./note-favorite-active.svg": 79635,
	"./note-favorite-inactive.svg": 12698,
	"./note-inactive.svg": 23255,
	"./pause-2.svg": 70382,
	"./pause.svg": 51947,
	"./pencil.svg": 50184,
	"./pin.svg": 92528,
	"./plane_end.svg": 18469,
	"./plane_start.svg": 22606,
	"./play-2.svg": 18676,
	"./play-next.svg": 86625,
	"./play.svg": 33138,
	"./plus.svg": 24491,
	"./question-mark.svg": 97631,
	"./send.svg": 46385,
	"./setting.svg": 99941,
	"./share.svg": 67300,
	"./sparkle.svg": 83747,
	"./star-fill.svg": 34592,
	"./star-four.svg": 69092,
	"./star-run.svg": 41463,
	"./star.svg": 40815,
	"./sun.svg": 17391,
	"./tag.svg": 48197,
	"./task-square.svg": 71280,
	"./teacher-active.svg": 38738,
	"./teacher-inactive.svg": 29023,
	"./thumbs-up.svg": 31066,
	"./training.svg": 81089,
	"./trash-2.svg": 81374,
	"./trash.svg": 36891,
	"./unlock.svg": 39099,
	"./video-play.svg": 95903,
	"./yandex.svg": 6876,
	"./youtube.svg": 72054,
	"./zipper.svg": 83421
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46669;